import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// packages/react/use-size/src/use-size.tsx
import * as React from "react";
import { useLayoutEffect } from "@radix-ui/react-use-layout-effect";
function useSize(element) {
  var _React$useState = React.useState(void 0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    size = _React$useState2[0],
    setSize = _React$useState2[1];
  useLayoutEffect(function () {
    if (element) {
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      var resizeObserver = new ResizeObserver(function (entries) {
        if (!Array.isArray(entries)) {
          return;
        }
        if (!entries.length) {
          return;
        }
        var entry = entries[0];
        var width;
        var height;
        if ("borderBoxSize" in entry) {
          var borderSizeEntry = entry["borderBoxSize"];
          var borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({
          width: width,
          height: height
        });
      });
      resizeObserver.observe(element, {
        box: "border-box"
      });
      return function () {
        return resizeObserver.unobserve(element);
      };
    } else {
      setSize(void 0);
    }
  }, [element]);
  return size;
}
export { useSize };